import Button from "@/designs/Button";
import CenterModal from "@/designs/CenterModal";
import Loader from "@/designs/Loader";
import {
  GetVistorsDocument,
  useUpdateVisitorMutation,
  Visitor,
} from "@/graphql/generated/schema";
import React, { useContext } from "react";
import { CMSModal } from "@/context";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "react-i18next";

interface DeleteRowProp {
  isOpen: boolean;
  onClose: () => void;
  timeline: Visitor[] | any;
}

const SignOutModal = ({ isOpen, onClose, timeline }: DeleteRowProp) => {
  const { theme } = useContext(CMSModal);
  const { t } = useTranslation();
  const [updateVisitor, { loading }] = useUpdateVisitorMutation({
    refetchQueries: [GetVistorsDocument],
  });

  const handleSave = async () => {
    const visitorsToSignOut = timeline.filter(
      (visitor: Visitor) => visitor.signedType === "In",
    );

    for (const visitor of visitorsToSignOut) {
      await updateVisitor({
        variables: {
          input: {
            _id: visitor.id,
            signedType: "Out",
          },
        },
      });
    }

    onClose();
  };

  return (
    <CenterModal isOpen={isOpen} onClose={onClose}>
      {loading && <Loader />}
      <div className="space-y-4">
        <h2
          className={twMerge(
            "font-semibold transition-colors",
            theme === "dark" ? "text-gray-100" : "",
          )}
        >
          {t("visitors.signOut.title")}{" "}
          {timeline.filter((v: Visitor) => v.signedType === "In").length}{" "}
          {t("visitors.signOut.visitorsLabel")}
        </h2>
        <p
          className={twMerge(
            "transition-colors",
            theme === "dark" ? "text-gray-400" : "text-gray-600",
          )}
        >
          {t("visitors.signOut.confirm")}
        </p>
        <div className="flex gap-4 items-center justify-end">
          <Button variant="outline" className="w-50" onClick={onClose}>
            {t("visitors.signOut.cancel")}
          </Button>
          <Button className="w-50" onClick={handleSave}>
            {t("visitors.signOut.signOutVisitors")}
          </Button>
        </div>
      </div>
    </CenterModal>
  );
};

export default SignOutModal;
